export default "__VITE_ASSET__CvXlrN6x__"